import { Component, OnInit, Renderer2 } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
const Excel = require("exceljs");
import { saveAs } from "file-saver";

import { DatePipe } from "@angular/common";
import Math from "exact-math";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "src/app/services/common.service";
import * as XLSX from "xlsx";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-subject",
  templateUrl: "./subject.component.html",
  styleUrls: ["./subject.component.css"],
})
export class SubjectComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  alphaPattern = "[a-zA-Z .,]*";
  SubjectForm: FormGroup;
  active = 1;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  selectedFiles: any;
  submitted = false;
  bulkcreate: any;
  bulk_form: FormGroup;
  view_File_name: any;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  subcreate: any;
  subjectList: any[];
  getsubject: any;
  editsubject: any;
  is_active = false;
  deletesubject: any;
  editstatus = false;
  subupdate: any;
  substatusupdate: any;
  editid: any;
  department: any;
  mappingData: any;
  dept = [];
  entryFields: boolean = false;
  createNew: boolean = true;
  create_self: any;
  self_status: any;
  isactiveswitch: any;
  isactiveswitchself: any;
  editbut: boolean;
  subname: any;
  subcode: any;
  depid: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  total: number;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  mapSectionForm: FormGroup;
  excelcontent: any;
  filtervalues: boolean;
  chiparray: any = [];
  section: any;
  isAnyRowSelect: any = -1;
  backendValidationErrors: null;
  sessionData: any;
  mappingTitle: string;
  mappingStr: any;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    public fileupload: CommonService,
    private renderer: Renderer2
  ) {}
  async ngOnInit() {
    this.searchForm = this.fb.group({
      id: [""],
      subjectname: [""],
      sessionname: [null],
      subjectcode: [""],
      depname: [""],
      section: [""],
    });

    this.SubjectForm = this.fb.group({
      id: [""],
      name: ["", [Validators.required]],
      code: ["", [Validators.required]],
      session: [""],
      department_id: ["", [Validators.required]],
      section: ["", [Validators.required]],
      is_active: [""],
    });

    this.SubjectForm.valueChanges.subscribe((data) => {
      this.backendValidationErrors = null;
    });

    this.mapSectionForm = this.fb.group({
      id: [""],
      sectionName: [""],
      sessionName: [""],
    });

    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });

    this.page = 1;
    this.getDropdownData();
    await this.getSubject();
    await this.getPage(this.page, true);
  }
  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.SubjectForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.SubjectForm.reset();
    this.submitted = false;
  }
  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.SubjectForm.reset();
    this.createNew = true;
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
      await this.getSubject();
    }
    const res = await this.serverCall(this.subjectList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  get forms() {
    return this.SubjectForm.controls;
  }

  get mapSectionFormCtrl() {
    return this.mapSectionForm.controls;
  }

  async doMappingWithSection() {
    let filterSelectedArray = [];
    this.subjectList
      .filter((list) => list.state)
      .forEach((lst) => {
        let id = String(lst.id);
        filterSelectedArray.push(id);
      });
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      subject_id: filterSelectedArray,
      section: this.mapSectionFormCtrl?.sectionName?.value,
      session_id: this.mapSectionFormCtrl?.sessionName?.value,
    };
    this.spinner.show();
    this.mappingData = await this.globalService.update(
      `subject/update-${this.mappingStr}`,
      requestPayload
    );
    if (this.mappingData["status"] === 200) {
      Swal.fire("Success!", this.mappingData["message"], "success");
      this.getSubject();
      this.spinner.hide();
      this.subjectList.forEach((list) => (list.state = false));
      this.onCheckboxClick();
      this.modalService.dismissAll();
    } else if (this.mappingData["status"] === 422) {
      this.backendValidationErrors =
        this.mappingData?.error["content"];
        this.spinner.hide();
      } else {
      this.spinner.hide();
      this.onCheckboxClick();
      this.modalService.dismissAll();
    }
  }

  checkAll(ev) {
    this.subjectList.forEach((list) => (list.state = ev.target.checked));
  }

  isAllChecked() {
    return this.subjectList.every((list) => list.state);
  }

  onCheckboxClick() {
    this.isAnyRowSelect = this.subjectList.findIndex((list) => list.state);
  }
  async getDropdownData() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];

    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.spinner.hide();
  }
  async createSubject(form: FormGroup) {
    this.submitted = true;

    if (this.SubjectForm.invalid) {
      return;
    }
    this.spinner.show();
    if (form.value.name.trim() == "") {
      Swal.fire("Warning!", "Please Provide Valid Subject Name", "warning");
    } else if (form.value.code.trim() == "") {
      Swal.fire("Warning!", "Please Provide Valid Subject Code", "warning");
    } else {
      const inputData = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        name: form.value.name,
        code: form.value.code,
        session_id: form.value.session,
        section: form.value.section,
        department_id: form.value.department_id,
        is_active: this.isactiveswitch
          ? this.isactiveswitch == true
            ? "1"
            : "0"
          : "0",
      };

      this.subcreate = await this.globalService.create(
        "subject/create",
        inputData
      );

      if (this.subcreate["status"] === 200) {
        Swal.fire("Success!", this.subcreate["message"], "success");
        this.spinner.show();
        this.getSubject();
        this.pageshow = false;
        this.reset();
        this.bulk_form.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, "modal-open");
      } else if (this.subcreate["status"] === 422) {
        this.backendValidationErrors = this.subcreate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }

  mappingSection(mappingSection, str) {
    this.mappingStr = str;
    if (this.ls.get("token")) {
      this.backendValidationErrors = null;
      this.mapSectionForm.reset();
      if (str == "section") {
        this.mappingTitle = "Map Section";
      } else {
        this.mappingTitle = "Map Session";
      }
      this.modalService.open(mappingSection, { scrollable: true });
    }
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.view_File_name = this.selectedFiles.item(0).name;
  }
  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }
  async BulkUpload(form: FormGroup) {
    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
    }
    let dataExport = [];

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(this.selectedFiles[0]);
    if (this.selectedFiles != null) {
      const file = this.selectedFiles.item(0);
      if (
        file.type !== "application/vnd.ms-excel" &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        this.spinner.hide();
        Swal.fire("Error!", "Only Excel files are allowed", "error");
        return;
      }

      if (file.size > 2097152) {
        Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
        return false;
      }
      if (
        file.type == "application/vnd.ms-excel" ||
        file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type == "application/vnd.oasis.opendocument.spreadsheet"
      ) {
        let formdata = new FormData();
        formdata.append("file", file);
        formdata.append("user_id", this.ls.get("createdBy"));
        formdata.append("vendor_id", this.ls.get("vendor_id"));
        formdata.append("upload_role_id", "4");
        formdata.append("role_id", String(this.storageService.getRole()));
        formdata.append("requester_type", "web");
        this.spinner.show();
        reader.onload = async (e: any) => {
          const binarystr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws);

          if (data.length > 100) {
            this.spinner.hide();
            Swal.fire(
              "Warning!",
              "Records more than 100 not be allowed",
              "warning"
            );

            return;
          } else {
            this.bulkcreate = await this.globalService.update(
              "subject/upload/excel",
              formdata
            );

            if (this.bulkcreate["status"] === 200) {
              let bulk = this.bulkcreate["content"];
              const expectedHeaders = [
                "subject",
                "subject_code",
                "department",
                "section",
                "session",
                "message",
              ];
              const missingDataRows = bulk.filter((row) => {
                return expectedHeaders.some((header) => !row[header]);
              });
              if (missingDataRows.length > 0) {
                Swal.fire(
                  "Warning!",
                  "Some rows are missing data for required headers. Please check the file.",
                  "warning"
                );
              } else {
                for (let i = 0; i < bulk.length; i++) {
                  dataExport.push({
                    Sno: i + 1,
                    subject: bulk[i].subject,
                    subject_code: bulk[i].subject_code,
                    department: bulk[i].department,
                    section: bulk[i].section,
                    session: bulk[i].session,
                    message: bulk[i].message,
                  });
                }

                var a = await this.fileupload.exportExcel(
                  dataExport,
                  "Subject List"
                );
                Swal.fire("Success!", this.bulkcreate["message"], "success");
                this.pageshow = true;
                this.bulk_form.reset();
                this.resetbulk();
              }
            }
          }
          this.spinner.hide();
        };
      }
    }
    this.spinner.hide();
    this.cancelFields();
  }

  Filter(subname, subcode, depid, section) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.subname != undefined && this.subname != "") {
      this.chiparray.push("Subname :" + " " + this.subname);
    }

    if (this.subcode != undefined && this.subcode != "") {
      this.chiparray.push("Subcode :" + " " + this.subcode);
    }

    if (this.searchForm.controls['sessionname'].value) {
      this.chiparray.push("Session :" + " " + this.sessionData?.find((list)=>{
        return list.id  == this.searchForm.controls['sessionname'].value
      }).session);
    }

    if (this.depid != undefined && this.depid != "") {
      var dept = this.dept.filter((x) => x.id == this.depid);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.section != undefined && this.section != "") {
      this.chiparray.push("Section :" + " " + this.section);
    }

    this.subname = subname;
    this.subcode = subcode;
    this.section = section;
    this.depid = depid;
    this.pageshow = true;
    this.page = 1;
    this.getSubject();
    this.spinner.hide();
  }
  res() {
    this.filtervalues = false;
    this.subname = null;
    this.subcode = null;
    this.depid = null;
    this.section = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getSubject();
  }
  resetbulk() {
    this.bulk_form.reset();
  }
  getSubject() {
    this.spinner.show();
    if (this.page === 1) {
      this.subjectList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size: this.page_size,
      name: this.subname ? this.subname : "",
      department_id: this.depid ? this.depid : "",
      code: this.subcode ? this.subcode : "",
      section: this.section ? this.section : "",
      session_id: this.searchForm.controls['sessionname'].value,
    };

    this.globalService.get("subject/list", filter).then((data) => {
      this.getsubject = data;
     
      if (this.getsubject["status"] === 200) {
        this.total_count = this.getsubject["content"].count;

        if (this.getsubject["content"]["rows"].length < this.page_size) {
          this.showLoadMore = true;
        }
  
        this.subjectList = this.getsubject["content"]["rows"];
        this.spinner.hide();
        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count / this.page_size);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.htmlpageshow = false;
        this.showLoadMore = true;
        this.spinner.hide();
      }
    });
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  switchself(e) {
    this.isactiveswitchself = e;
  }
  editSubject(id) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      this.editbut = true;
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.active = 2;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.editsubject = await this.globalService.get("subject/get", filter);
        let comp_details = this.editsubject["content"];

        if (this.editsubject["status"] === 200) {
          this.SubjectForm.controls["id"].setValue(comp_details.id);
          this.SubjectForm.controls["section"].setValue(comp_details.section);
          this.SubjectForm.controls["name"].setValue(comp_details.name);
          this.SubjectForm.controls["code"].setValue(comp_details.code);
          this.SubjectForm.controls["department_id"].setValue(
            comp_details.department_id
          );
          this.SubjectForm.controls["session"].setValue(
            comp_details.session_id
          );
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  reset() {
    this.submitted = false;
    this.SubjectForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getSubject();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getSubject();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getSubject();
  }

  SubjectStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        this.manualUpdate = value;
        this.spinner.hide();
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };
        this.substatusupdate = await this.globalService.update(
          "subject/update/status",
          inputData
        );
        if (this.substatusupdate["status"] === 200) {
          Swal.fire("Success!", this.substatusupdate["message"], "success");
          this.pageshow = true;
          this.getSubject();
          this.spinner.hide();
        }
        if (this.substatusupdate["status"] != 200) {
          this.spinner.hide();
          this.pageshow = true;
          this.getSubject();
        }
      } else {
        this.pageshow = true;
        this.getSubject();
      }
    });
    this.spinner.hide();
  }

  async updateSubject(form: FormGroup) {
    this.submitted = true;

   
    this.spinner.show();
    
      const inputData = {
        id: form.value.id,
        vendor_id: this.ls.get("vendor_id"),
        is_active: this.is_active ? this.is_active : this.editstatus,
        session_id: form.value.session,
        user_id: this.ls.get("createdBy"),
        name: form.value.name,
        code: form.value.code,
        department_id: form.value.department_id,
        section: form.value.section,
      };

      this.subupdate = await this.globalService.update(
        "subject/update",
        inputData
      );

      if (this.subupdate["status"] === 200) {
        Swal.fire("Success!", this.subupdate["message"], "success");
        this.spinner.show();
        this.editbut = false;
        this.pageshow = true;
        this.getSubject();
        this.reset();
        this.bulk_form.reset();
        this.entryFields = false;
        this.createNew = true;
        this.backendValidationErrors = null;
        this.renderer.removeClass(document.body, "modal-open");
      } else if (this.subupdate["status"] === 422) {
        this.backendValidationErrors = this.subupdate?.error["content"];
      } else {
        this.cancelFields();
        this.backendValidationErrors = null;
      }
      this.spinner.hide();
  }

  async downloadSampleTemplate() {
    let departmentdrop = [];
    this.dept.forEach((e) => {
      departmentdrop.push(e.name);
    });
    let sessionDropDownData = [];
    this.sessionData.forEach((list) => {
      sessionDropDownData.push(
        `${list.session} (${new DatePipe("en-US").transform(
          list.start_date,
          "yyyy-dd-MM"
        )} - ${new DatePipe("en-US").transform(list.end_date, "yyyy-dd-MM")})`
      );
    });
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "subject";
    worksheet.getCell("C1").value = "subject_code";
    worksheet.getCell("D1").value = "department";
    worksheet.getCell("E1").value = "section";
    worksheet.getCell("F1").value = "session";

    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;

    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "Digital Electronics";
    worksheet.getCell("C2").value = "DE0001";

    const dobCol = worksheet.getColumn(16);
    dobCol.hidden = true;
    const dobCol1 = worksheet.getColumn(15);
    dobCol1.hidden = true;

    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`D${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$P$1:$P$1048576"],
      };
      worksheet.getCell(`F${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$O$1:$O$1048576"],
      };
    }
    for (let index = 0; index < sessionDropDownData.length; index++) {
      worksheet.getCell(`O${index + 1}`).value = sessionDropDownData[index];
    }
    for (let index = 0; index < departmentdrop.length; index++) {
      worksheet.getCell(`P${index + 1}`).value = departmentdrop[index];
      const element = departmentdrop[index];
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Subject Sample List" + ".xlsx");
    });
  }

  async deleteSubject(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
        };
        this.deletesubject = await this.globalService.delete(
          "subject/delete",
          filter
        );
        if (this.deletesubject["status"] === 200) {
          this.subjectList = [];
          Swal.fire("Success!", this.deletesubject["message"], "success");
          this.pageshow = true;
          this.getSubject();
          this.spinner.hide();
        }
      }
    });
    this.spinner.hide();
  }

  formAddReset() {
    this.SubjectForm.reset();
    this.editbut = false;
    this.isactiveswitch = false;
    this.bulk_form.reset();
  }

  formUpdateReset() {
    this.SubjectForm.controls["id"].setValue(this.editsubject["content"].id);
    this.SubjectForm.controls["name"].setValue(
      this.editsubject["content"].name
    );
    this.SubjectForm.controls["code"].setValue(
      this.editsubject["content"].code
    );
    this.SubjectForm.controls["department_id"].setValue(
      this.editsubject["content"].department_id
    );
    this.SubjectForm.controls["section"].setValue(
      this.editsubject["content"].section
    );
    this.SubjectForm.reset();
    this.SubjectForm.get("id").setValue(this.editsubject["content"].id);
  }

  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getSubject();
  }
}
